/* LE-Klickanalyse – Tracker, Stufe 1
 *
 * Zählt auf living-electronics.com: Klicks (welches Element, welche Section, ob
 * etwas passiert ist), Scrolltiefe, aktive Zeit, Verweildauer je Section,
 * Zögern über Kaufknopf/Preis, Tab-Wechsel, Hörproben (welcher Clip, wie lange),
 * Warenkorb und Kasse, JS-/Ladefehler, Ladezeiten und den ungefähren Standort (Land laut
 * Shopify-Geolokalisierung, dazu die Zeitzone des Geräts als Regionshinweis).
 *
 * Läuft erst, wenn der Besucher im Shopify-Cookie-Banner Statistik erlaubt.
 * Keine Aufzeichnung von Seiteninhalten oder Eingaben, keine IP.
 *
 * Eigene Geräte ausnehmen: Seite einmal mit ?lx=off aufrufen (?lx=on hebt es auf).
 * Fehlersuche: ?lx=debug schreibt jedes Ereignis in die Konsole.
 *
 * Quelle: ~/Documents/LE-Klickanalyse/tracker/le-ux.js — im Theme als assets/le-ux.js.
 */
(function () {
  'use strict';

  var CFG = window.LEUX || {};
  if (!CFG.endpoint || window.__lxLoaded) return;
  window.__lxLoaded = true;

  var VERSION = 1;
  var SESSION_GAP = 30 * 60 * 1000;   // neue Sitzung nach 30 min Pause
  var IDLE_AFTER = 30 * 1000;         // ohne Bewegung zählt die Zeit nicht als aktiv
  var FLUSH_EVERY = 10 * 1000;
  var MAX_ERRORS = 10;
  var MAX_HOVERS = 30;
  var MAX_UPSCROLLS = 20;
  // Kaufknöpfe und Preise, über denen Zögern gemessen wird. Die LE-Seiten haben eigene Knöpfe
  // (Hero-Kaufknopf, "I WANT THIS"-Leiste); was hier fehlt, fängt BUY_RE über den Text.
  var HOVER_SEL = [
    'form[action*="/cart/add"] [type=submit]', '[name="add"]', '[name="checkout"]',
    '.shopify-payment-button', '#stickyFooter a', '#stickyFooter button', '#stickyCTA',
    '.hero-buy-button', '.primary-cta', '.price', '.price-item', '.hero-price-section',
    '[class*="le-offer"] button'
  ].join(',');
  var BUY_RE = /add to cart|buy|i want this|get (it|all|the bundle)|checkout|warenkorb|kaufen|agregar|comprar/i;
  var CHECKOUT_SEL = '[name="checkout"], a[href*="/checkout"], .shopify-payment-button, [data-shopify="payment-button"]';
  var INTERACTIVE_SEL = 'a[href], button, input, select, textarea, label, summary, [role=button], [role=link], [role=tab], [role=checkbox], [onclick], [data-src], [tabindex]:not([tabindex="-1"])';

  var store = storage();
  var qs = new URLSearchParams(location.search);
  var lxParam = qs.get('lx');
  if (lxParam === 'off') store.set('lx_off', '1');
  if (lxParam === 'on') { store.del('lx_off'); store.del('lx_debug'); }
  if (lxParam === 'debug') store.set('lx_debug', '1');
  var DEBUG = store.get('lx_debug') === '1';

  if (store.get('lx_off') === '1') return;
  if (navigator.webdriver) return;
  if (/bot|crawl|spider|slurp|headless|lighthouse|pagespeed|gtmetrix|preview|facebookexternalhit/i.test(navigator.userAgent)) return;
  if (window.Shopify && window.Shopify.designMode) return;   // Theme-Editor
  if (window.top !== window.self) return;                    // eingebettet, z. B. Editor-Vorschau
  if (/^\/(account|challenge|password)/.test(location.pathname)) return;   // Kundenkonto: nie

  // Bis zur Zustimmung wird nur im Arbeitsspeicher gesammelt (Fehler, Ladezeiten),
  // nichts gespeichert und nichts gesendet. Ohne Zustimmung verfällt es mit der Seite.
  var t0 = performance.now();
  var started = false, stopped = false;
  var queue = [];
  var errors = [], errorKeys = {};
  var vit = {};
  var oFetch = window.fetch;

  collectEarlyErrors();
  watchErrors();
  watchVitals();
  whenConsent(start);

  // ---------------------------------------------------------------- Zustimmung

  function consentState() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return null;
    return !!cp.analyticsProcessingAllowed();
  }

  function whenConsent(cb) {
    var once = function () { if (!started && !stopped) cb(); };
    document.addEventListener('visitorConsentCollected', function (e) {
      if (e.detail && e.detail.analyticsAllowed) { stopped = false; once(); } else stop();
    });
    var s = consentState();
    if (s === true) return once();
    if (s === null && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (!err && consentState() === true) once();
      });
    }
  }

  function stop() {
    stopped = true;
    queue = [];
    ['lx_vid', 'lx_vn', 'lx_s', 'lx_tag'].forEach(store.del);
  }

  // ---------------------------------------------------------------- Start

  var vid, sid, pv, sess, seq = 0;
  var act = 0, hiddenCount = 0, hiddenMs = 0, hiddenSince = 0;
  var lastActivity = Date.now();
  var maxDepth = 0, upscrolls = 0, docH = 0;
  var secStats = {}, secVisible = {}, layoutSent = '';
  var clicks = 0, lastClick = null;
  var media = [], mediaSeen = typeof WeakSet === 'function' ? new WeakSet() : null;
  var hovers = 0, hover = null, mouseX = 0, mouseY = 0;
  var lastSummary = '';

  function start() {
    started = true;
    var now = Date.now();
    vid = store.get('lx_vid');
    if (!vid) { vid = rid(); store.set('lx_vid', vid); }
    sess = parseJSON(store.get('lx_s'));
    if (!sess || now - sess.last > SESSION_GAP) {
      var vn = (parseInt(store.get('lx_vn'), 10) || 0) + 1;
      store.set('lx_vn', String(vn));
      sess = { id: rid(), start: now, last: now, n: 0, vn: vn, src: firstTouch() };
    }
    sess.n += 1;
    sess.last = now;
    store.set('lx_s', JSON.stringify(sess));
    sid = sess.id;
    pv = rid();

    var th = (window.Shopify && window.Shopify.theme) || {};
    push('pv', {
      path: cleanPath(location.pathname),
      tpl: CFG.template || '',
      h: CFG.handle || '',
      pid: CFG.productId || null,
      th: th.id || null, tr: th.role || '',
      ref: refHost(),
      src: sess.src,
      vn: sess.vn, pn: sess.n,
      dev: deviceType(), os: osName(), br: browserName(),
      vw: innerWidth, vh: innerHeight, dpr: Math.round((devicePixelRatio || 1) * 10) / 10,
      lang: (navigator.language || '').slice(0, 5),
      cc: (window.Shopify && window.Shopify.country) || '',
      geo: sess.geo || null,
      tz: timeZone(),
      ct: cartToken()
    });
    if (!sess.geo) detectCountry();

    errors.forEach(function (e) { push('err', e); });
    errors = null;

    watchActivity();
    watchScroll();
    watchSections();
    watchClicks();
    watchHover();
    watchMedia();
    watchCart();
    if (cartToken()) tagCart();

    setInterval(tick, 1000);
    setInterval(function () { flush(false); }, FLUSH_EVERY);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        hiddenCount += 1; hiddenSince = Date.now();
        flush(true);
      } else if (hiddenSince) {
        hiddenMs += Date.now() - hiddenSince; hiddenSince = 0;
        lastActivity = Date.now();
      }
    });
    addEventListener('pagehide', function () { endHover(); closeAllMedia(); flushPendingClick(true); flush(true); });
  }

  // ---------------------------------------------------------------- Zeit & Aktivität

  function watchActivity() {
    var mark = function () { lastActivity = Date.now(); };
    ['pointerdown', 'keydown', 'scroll', 'wheel', 'touchstart'].forEach(function (t) {
      addEventListener(t, mark, { passive: true, capture: true });
    });
    var lastMove = 0;
    addEventListener('mousemove', function () {
      var n = Date.now();
      if (n - lastMove > 500) { lastMove = n; lastActivity = n; }
    }, { passive: true });
  }

  function isActive() {
    if (document.visibilityState !== 'visible') return false;
    return Date.now() - lastActivity < IDLE_AFTER || mediaPlaying();
  }

  function tick() {
    if (stopped || !isActive()) return;
    act += 1000;
    for (var id in secVisible) {
      if (!secVisible[id]) continue;
      var s = secStats[id] || (secStats[id] = [0, now()]);
      s[0] += 1000;
    }
  }

  // ---------------------------------------------------------------- Scrollen

  function watchScroll() {
    var ticking = false, dirStart = scrollY, lastY = scrollY, goingUp = false;
    var onScroll = function () {
      ticking = false;
      var y = scrollY;
      docH = docHeight();
      var depth = Math.min(100, Math.round((y + innerHeight) / docH * 100));
      if (depth > maxDepth) maxDepth = depth;
      var up = y < lastY;
      if (up !== goingUp) {
        // Richtungswechsel: eine große Aufwärtsbewegung beendet sich hier
        if (goingUp && dirStart - lastY > innerHeight * 0.5 && upscrolls < MAX_UPSCROLLS) {
          upscrolls += 1;
          push('u', { fr: sectionAtY(dirStart + innerHeight / 2), to: sectionAtY(lastY + innerHeight / 2), d: Math.round(dirStart - lastY) });
        }
        goingUp = up; dirStart = lastY;
      }
      lastY = y;
    };
    addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
    }, { passive: true });
    onScroll();
  }

  // ---------------------------------------------------------------- Sections

  function sectionEls() {
    return Array.prototype.slice.call(document.querySelectorAll('[id^="shopify-section-"]'));
  }

  function watchSections() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var id = secName(en.target);
        var h = en.boundingClientRect.height;
        var seen = en.intersectionRect.height;
        // Gilt als "im Bild", wenn die Hälfte der Section oder die Hälfte des Bildschirms gefüllt ist
        var vis = en.isIntersecting && h > 0 && (seen >= h * 0.5 || seen >= innerHeight * 0.5);
        secVisible[id] = vis;
        if (vis && !secStats[id]) secStats[id] = [0, now()];
      });
    }, { threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] });
    sectionEls().forEach(function (el) { if (el.offsetHeight > 0) io.observe(el); });
  }

  function layout() {
    var top = scrollY;
    return sectionEls().filter(function (el) { return el.offsetHeight > 0; }).map(function (el) {
      var r = el.getBoundingClientRect();
      return [secName(el), Math.round(r.top + top), Math.round(r.height)];
    });
  }

  function sectionAtY(pageY) {
    var els = sectionEls();
    for (var i = 0; i < els.length; i++) {
      var r = els[i].getBoundingClientRect(), top = r.top + scrollY;
      if (pageY >= top && pageY < top + r.height) return secName(els[i]);
    }
    return '';
  }

  // ---------------------------------------------------------------- Klicks

  function watchClicks() {
    document.addEventListener('click', function (e) {
      if (stopped) return;
      var el = e.target && e.target.nodeType === 3 ? e.target.parentElement : e.target;
      if (!el || !el.closest) return;
      flushPendingClick(false);
      clicks += 1;
      var hit = el.closest(INTERACTIVE_SEL);
      var target = hit || el;
      var interactive = !!hit || hasPointerCursor(el);
      var r = target.getBoundingClientRect();
      var secEl = target.closest('[id^="shopify-section-"]');
      var sr = secEl ? secEl.getBoundingClientRect() : null;
      var a = target.closest('a[href]');
      var c = {
        sel: selectorOf(target),
        tag: target.tagName.toLowerCase(),
        txt: labelOf(target),
        href: a ? linkOf(a) : '',
        sec: secEl ? secName(secEl) : '',
        act: interactive ? 1 : 0,
        rx: r.width ? round2((e.clientX - r.left) / r.width) : null,
        ry: r.height ? round2((e.clientY - r.top) / r.height) : null,
        sx: sr && sr.width ? round2((e.clientX - sr.left) / sr.width) : null,
        sy: sr && sr.height ? round2((e.clientY - sr.top) / sr.height) : null,
        cx: Math.round(e.clientX), cy: Math.round(e.clientY),
        y: Math.round(e.clientY + scrollY), dh: docHeight()
      };
      if (target.closest(CHECKOUT_SEL)) {
        push('co', { via: target.closest('.shopify-payment-button, [data-shopify="payment-button"]') ? 'buynow' : 'checkout', sec: c.sec, txt: c.txt });
        flush(true);
      }
      if (hover && hover.el && hover.el.contains(target)) hover.clk = 1;
      watchReaction(c);
    }, true);
  }

  // Ob nach dem Klick binnen einer Sekunde irgendetwas passiert (DOM, Scroll, Ton, Seitenwechsel).
  // Bleibt alles still, ist das entweder ein Klick auf etwas Totes oder ein kaputter Knopf.
  var pending = null;
  function watchReaction(c) {
    var changed = 0;
    var mo = new MutationObserver(function (list) { changed += list.length; });
    mo.observe(document.documentElement, {
      subtree: true, childList: true, characterData: true,
      attributeFilter: ['class', 'open', 'hidden', 'aria-expanded', 'aria-hidden', 'aria-selected', 'aria-pressed', 'disabled', 'src', 'value', 'checked']
    });
    var y0 = scrollY, plays0 = playCount;
    lastClick = { at: Date.now(), txt: c.txt, sec: c.sec };
    pending = {
      c: c, mo: mo,
      done: function (nav) {
        mo.disconnect();
        c.re = nav ? 2 : (changed > 0 || Math.abs(scrollY - y0) > 20 || playCount > plays0) ? 1 : 0;
        push('c', c, c.tAt);
      }
    };
    c.tAt = now();
    pending.timer = setTimeout(function () { flushPendingClick(false); }, 1000);
  }

  function flushPendingClick(nav) {
    if (!pending) return;
    var p = pending; pending = null;
    clearTimeout(p.timer);
    p.done(nav);
  }

  // ---------------------------------------------------------------- Zögern (nur Maus)

  function watchHover() {
    if (!window.matchMedia || !matchMedia('(pointer: fine)').matches) return;
    // Über mousemove statt pointerover/out: robuster bei verschachtelten Knöpfen,
    // und ausgewertet wird nur, wenn sich das Element unter der Maus ändert.
    var lastTarget = null;
    document.addEventListener('mousemove', function (e) {
      mouseX = e.clientX; mouseY = e.clientY;
      var t = e.target;
      if (t === lastTarget || !t || !t.closest) return;
      lastTarget = t;
      if (hover && hover.el.contains(t)) return;
      if (hover) endHover();
      var el = t.closest(HOVER_SEL);
      if (!el) {
        var b = t.closest('button, a[href]');
        if (b && BUY_RE.test(b.innerText || b.getAttribute('aria-label') || '')) el = b;
      }
      if (el) hover = { el: el, at: Date.now(), clk: 0 };
    }, { passive: true, capture: true });
    document.documentElement.addEventListener('mouseleave', function () { lastTarget = null; endHover(); });
    // Scrollt der Knopf unter der stillstehenden Maus weg, endet das Zögern
    addEventListener('scroll', function () {
      if (!hover) return;
      var unter = document.elementFromPoint(mouseX, mouseY);
      if (!unter || !hover.el.contains(unter)) { lastTarget = null; endHover(); }
    }, { passive: true });
    addEventListener('blur', endHover);
    document.addEventListener('visibilitychange', endHover);
  }

  function endHover() {
    if (!hover) return;
    var ms = Date.now() - hover.at, el = hover.el, clk = hover.clk;
    hover = null;
    if (ms < 400 || hovers >= MAX_HOVERS) return;
    hovers += 1;
    var secEl = el.closest('[id^="shopify-section-"]');
    push('h', { sel: selectorOf(el), txt: labelOf(el), sec: secEl ? secName(secEl) : '', ms: ms, clk: clk });
  }

  // ---------------------------------------------------------------- Hörproben

  // Alle Player im Theme spielen über new Audio()/<audio>/WaveSurfer-MediaElement.
  // Die Elemente hängen oft nicht im DOM, deshalb wird play() selbst angezapft.
  var playCount = 0;
  function watchMedia() {
    var proto = window.HTMLMediaElement && HTMLMediaElement.prototype;
    if (!proto) return;
    var oPlay = proto.play;
    proto.play = function () {
      try { attachMedia(this); } catch (e) { /* nie den Player stören */ }
      return oPlay.apply(this, arguments);
    };
    document.addEventListener('play', function (e) {
      if (e.target && e.target.tagName && /^(AUDIO|VIDEO)$/.test(e.target.tagName)) attachMedia(e.target);
    }, true);
  }

  function attachMedia(m) {
    if (mediaSeen) { if (mediaSeen.has(m)) return; mediaSeen.add(m); }
    else { if (m.__lx) return; m.__lx = 1; }
    var st = { m: m, open: false };
    media.push(st);
    var open = function () {
      var src = fileOf(m.currentSrc || m.src);
      if (st.open && st.src === src) return;
      if (st.open) close(st, false);
      var recent = lastClick && Date.now() - lastClick.at < 2500;
      if (m.muted && !recent) return;                // stumme Hintergrundvideos
      playCount += 1;
      st.open = true; st.src = src; st.at = now();
      st.lab = recent ? lastClick.txt : ''; st.sec = recent ? lastClick.sec : '';
      st.l = 0; st.p = 0; st.last = m.currentTime || 0; st.res = (m.currentTime || 0) > 0.5 ? 1 : 0;
    };
    m.addEventListener('play', open);
    m.addEventListener('playing', open);
    m.addEventListener('timeupdate', function () {
      if (!st.open) return;
      var d = m.currentTime - st.last;
      if (d > 0 && d < 2) st.l += d;
      st.last = m.currentTime;
      if (m.duration && isFinite(m.duration)) st.p = Math.max(st.p, m.currentTime / m.duration);
    });
    m.addEventListener('pause', function () { if (st.open) close(st, false); });
    m.addEventListener('ended', function () { if (st.open) close(st, true); });
    m.addEventListener('emptied', function () { if (st.open) close(st, false); });
    m.addEventListener('error', function () {
      pushError({ ty: 'media', msg: 'media error ' + (m.error ? m.error.code : '?'), f: fileOf(m.currentSrc || m.src) });
    });
    if (!m.paused) open();
  }

  function close(st, ended) {
    st.open = false;
    var m = st.m;
    push('m', {
      src: st.src, lab: st.lab, sec: st.sec,
      kind: m.tagName === 'VIDEO' ? 'v' : 'a',
      dur: m.duration && isFinite(m.duration) ? Math.round(m.duration * 10) / 10 : null,
      l: Math.round(st.l * 10) / 10, p: round2(ended ? 1 : st.p), end: ended ? 1 : 0, res: st.res
    }, st.at);
  }

  function closeAllMedia() { media.forEach(function (st) { if (st.open) close(st, false); }); }
  function mediaPlaying() { return media.some(function (st) { return st.open && !st.m.paused; }); }

  // ---------------------------------------------------------------- Warenkorb & Kasse

  function watchCart() {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = oFetch.apply(window, arguments);
      if (/\/cart\/add/.test(url)) {
        var v = variantOf(init && init.body);
        p.then(function (r) { onAdd(r.ok, r.status, v); }, function () { onAdd(false, 0, v); });
      }
      return p;
    };
    var oOpen = XMLHttpRequest.prototype.open, oSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) { this.__lxUrl = String(url || ''); return oOpen.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function (body) {
      if (/\/cart\/add/.test(this.__lxUrl || '')) {
        var x = this, v = variantOf(body);
        x.addEventListener('loadend', function () { onAdd(x.status >= 200 && x.status < 300, x.status, v); });
      }
      return oSend.apply(this, arguments);
    };
    // Nur echte Formular-Absendungen ohne JS: Dawn fängt den Submit ab (preventDefault) und
    // nimmt fetch — das zählt schon der fetch-Haken. Lauscht deshalb ganz am Ende (window, Bubble).
    addEventListener('submit', function (e) {
      var f = e.target, action = (f && f.getAttribute && f.getAttribute('action')) || '';
      if (/\/cart\/add/.test(action) && !e.defaultPrevented) {
        var input = f.querySelector('[name="id"]');
        push('atc', { ok: null, st: null, v: input ? input.value : null, sec: lastClick ? lastClick.sec : '', lab: lastClick ? lastClick.txt : '', form: 1 });
        flush(true);
      }
    }, false);
  }

  function onAdd(ok, status, variant) {
    push('atc', { ok: ok ? 1 : 0, st: status, v: variant, sec: lastClick ? lastClick.sec : '', lab: lastClick ? lastClick.txt : '' });
    flush(true);
    if (ok) tagCart();
  }

  // Schreibt Besucher- und Sitzungs-ID als versteckte Warenkorb-Attribute (Unterstrich = in der
  // Kasse unsichtbar). Sie landen an der Bestellung, so lässt sich jeder Kauf dem Besuch zuordnen.
  function tagCart() {
    var token = cartToken();
    var key = (token || '-') + '|' + sid;
    if (store.get('lx_tag') === key) return;
    try {
      oFetch.call(window, '/cart/update.js', {
        method: 'POST', keepalive: true, credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { _lx_vid: vid, _lx_sid: sid } })
      }).then(function (r) {
        if (r.ok) store.set('lx_tag', (cartToken() || '-') + '|' + sid);
      }, function () {});
    } catch (e) { /* egal */ }
  }

  function variantOf(body) {
    try {
      if (!body) return null;
      if (typeof FormData !== 'undefined' && body instanceof FormData) return body.get('id');
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return body.get('id');
      if (typeof body === 'string') {
        if (body.charAt(0) === '{') {
          var j = JSON.parse(body);
          return j.id || (j.items && j.items[0] && j.items[0].id) || null;
        }
        return new URLSearchParams(body).get('id');
      }
    } catch (e) { /* egal */ }
    return null;
  }

  // Land des Besuchers, wie Shopify es aus der IP ermittelt (dieselbe Abfrage nutzt Shopifys
  // Länder-Vorschlag). Einmal pro Sitzung; die IP sehen wir dabei nicht.
  function detectCountry() {
    try {
      oFetch.call(window, '/browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var c = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
          if (!c || stopped) return;
          sess.geo = String(c).slice(0, 2);
          store.set('lx_s', JSON.stringify(sess));
          push('geo', { c: sess.geo });
        }, function () {});
    } catch (e) { /* egal */ }
  }

  function timeZone() {
    try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) { return ''; }
  }

  function cartToken() {
    var m = document.cookie.match(/(?:^|;\s*)cart=([^;]+)/);
    return m ? decodeURIComponent(m[1]).split('?')[0] : '';
  }

  // ---------------------------------------------------------------- Fehler & Ladezeiten

  function collectEarlyErrors() {
    if (window.__lxEL) removeEventListener('error', window.__lxEL, true);
    (window.__lxE || []).forEach(function (x) {
      if (x[3]) pushError({ ty: 'res', msg: 'load failed', f: fileOf(x[3]) });
      else pushError({ ty: 'js', msg: String(x[0] || '').slice(0, 160), f: fileOf(x[1]) + ':' + (x[2] || 0) });
    });
  }

  function watchErrors() {
    addEventListener('error', function (e) {
      var t = e.target;
      if (t && t !== window && t.tagName) {
        var src = t.currentSrc || t.src || t.href;
        if (src) pushError({ ty: 'res', msg: 'load failed', f: fileOf(src), tag: t.tagName.toLowerCase() });
        return;
      }
      if (/^(chrome|moz|safari|safari-web)-extension:/.test(e.filename || '')) return;
      pushError({ ty: 'js', msg: String(e.message || '').slice(0, 160), f: fileOf(e.filename) + ':' + (e.lineno || 0) });
    }, true);
    addEventListener('unhandledrejection', function (e) {
      var r = e.reason;
      pushError({ ty: 'promise', msg: String((r && r.message) || r || '').slice(0, 160), f: '' });
    });
  }

  function pushError(e) {
    var key = e.ty + e.msg + e.f;
    if (errorKeys[key]) return;
    errorKeys[key] = 1;
    if (Object.keys(errorKeys).length > MAX_ERRORS) return;
    if (errors) errors.push(e); else push('err', e);
  }

  function watchVitals() {
    if (!('PerformanceObserver' in window)) return;
    var obs = function (type, fn, extra) {
      try {
        var o = new PerformanceObserver(function (l) { l.getEntries().forEach(fn); });
        var opts = { type: type, buffered: true };
        for (var k in extra) opts[k] = extra[k];
        o.observe(opts);
      } catch (e) { /* Browser kann es nicht */ }
    };
    obs('largest-contentful-paint', function (en) { vit.lcp = Math.round(en.startTime); });
    obs('paint', function (en) { if (en.name === 'first-contentful-paint') vit.fcp = Math.round(en.startTime); });
    obs('layout-shift', function (en) { if (!en.hadRecentInput) vit.cls = Math.round(((vit.cls || 0) + en.value) * 1000) / 1000; });
    obs('event', function (en) { if (en.interactionId && en.duration > (vit.inp || 0)) vit.inp = Math.round(en.duration); }, { durationThreshold: 40 });
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    var readNav = function () {
      nav = performance.getEntriesByType('navigation')[0];
      if (!nav) return;
      vit.ttfb = Math.round(nav.responseStart);
      if (nav.loadEventEnd) vit.load = Math.round(nav.loadEventEnd);
    };
    if (nav) readNav();
    addEventListener('load', function () { setTimeout(readNav, 0); });
  }

  // ---------------------------------------------------------------- Senden

  function push(k, data, at) {
    if (stopped) return;
    data.k = k;
    data.t = at != null ? at : now();
    delete data.tAt;
    queue.push(data);
    if (DEBUG) console.log('[lx]', k, data);
  }

  function summary() {
    docH = docHeight();
    var s = {
      act: act, tot: now(), sd: maxDepth, dh: docH, ups: upscrolls,
      hid: hiddenCount, hms: hiddenMs + (hiddenSince ? Date.now() - hiddenSince : 0),
      nc: clicks, sec: secStats, vit: vit
    };
    var lay = layout();
    var layKey = lay.map(function (x) { return x[0] + Math.round(x[1] / 200) + Math.round(x[2] / 200); }).join(',');
    if (layKey !== layoutSent) { s.lay = lay; layoutSent = layKey; }
    return s;
  }

  function flush(final) {
    if (!started || stopped) return;
    var s = summary();
    var sKey = JSON.stringify([s.act, s.sd, s.ups, s.hid, s.nc, s.sec, s.vit, !!s.lay]);
    if (sKey !== lastSummary || final) { lastSummary = sKey; push('sum', s); }
    if (!queue.length) return;
    if (sess) { sess.last = Date.now(); store.set('lx_s', JSON.stringify(sess)); }
    var events = queue; queue = [];
    // Beacons dürfen nicht zu groß werden — notfalls aufteilen
    while (events.length) {
      var chunk = events.splice(0, 150);
      send({ v: VERSION, vid: vid, sid: sid, pv: pv, q: seq++, e: chunk });
    }
  }

  function send(payload) {
    var body = JSON.stringify(payload);
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(CFG.endpoint, body)) return;
    } catch (e) { /* weiter mit fetch */ }
    try {
      oFetch.call(window, CFG.endpoint, { method: 'POST', body: body, keepalive: body.length < 60000, credentials: 'omit', headers: { 'Content-Type': 'text/plain' } });
    } catch (e) { /* verloren */ }
  }

  // ---------------------------------------------------------------- Helfer

  function now() { return Math.round(performance.now() - t0); }
  function round2(x) { return Math.round(Math.max(0, Math.min(1, x)) * 100) / 100; }
  function rid() {
    var a = new Uint8Array(10);
    (window.crypto || window.msCrypto).getRandomValues(a);
    return Array.prototype.map.call(a, function (b) { return (b % 36).toString(36); }).join('');
  }
  function parseJSON(s) { try { return s ? JSON.parse(s) : null; } catch (e) { return null; } }
  function docHeight() {
    var d = document.documentElement, b = document.body;
    return Math.max(d.scrollHeight, b ? b.scrollHeight : 0, innerHeight);
  }

  function storage() {
    var ls = null;
    try { ls = window.localStorage; ls.setItem('lx_t', '1'); ls.removeItem('lx_t'); } catch (e) { ls = null; }
    var mem = {};
    return {
      get: function (k) { try { return ls ? ls.getItem(k) : mem[k]; } catch (e) { return mem[k]; } },
      set: function (k, v) { try { if (ls) ls.setItem(k, v); else mem[k] = v; } catch (e) { mem[k] = v; } },
      del: function (k) { try { if (ls) ls.removeItem(k); } catch (e) { /* egal */ } delete mem[k]; }
    };
  }

  function firstTouch() {
    var p = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
      var v = qs.get(k);
      if (v) p[k.replace('utm_', '')] = v.slice(0, 120);
    });
    if (qs.get('fbclid')) p.fb = 1;
    if (qs.get('gclid') || qs.get('gbraid') || qs.get('wbraid')) p.g = 1;
    if (qs.get('ttclid')) p.tt = 1;
    p.ref = refHost();
    p.land = cleanPath(location.pathname);
    return p;
  }

  function refHost() {
    try {
      if (!document.referrer) return '';
      var u = new URL(document.referrer);
      return u.host === location.host ? 'intern' : u.host.replace(/^www\./, '');
    } catch (e) { return ''; }
  }

  function deviceType() {
    var coarse = window.matchMedia && matchMedia('(pointer: coarse)').matches;
    var small = Math.min(screen.width, screen.height);
    if (coarse && small < 600) return 'mobile';
    if (coarse) return 'tablet';
    return 'desktop';
  }

  function osName() {
    var ua = navigator.userAgent;
    if (/iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1)) return 'ios';
    if (/Android/.test(ua)) return 'android';
    if (/Mac OS X/.test(ua)) return 'mac';
    if (/Windows/.test(ua)) return 'windows';
    if (/Linux|CrOS/.test(ua)) return 'linux';
    return 'other';
  }

  function browserName() {
    var ua = navigator.userAgent;
    if (/Instagram/.test(ua)) return 'instagram';
    if (/FBAN|FBAV|FB_IAB/.test(ua)) return 'facebook';
    if (/TikTok|musical_ly|BytedanceWebview/i.test(ua)) return 'tiktok';
    if (/Edg\//.test(ua)) return 'edge';
    if (/OPR\/|Opera/.test(ua)) return 'opera';
    if (/SamsungBrowser/.test(ua)) return 'samsung';
    if (/Firefox|FxiOS/.test(ua)) return 'firefox';
    if (navigator.brave) return 'brave';
    if (/Chrome|CriOS/.test(ua)) return 'chrome';
    if (/Safari/.test(ua)) return 'safari';
    return 'other';
  }

  function secName(el) {
    var id = el.id.replace(/^shopify-section-/, '');
    var i = id.indexOf('__');
    return i >= 0 ? id.slice(i + 2) : id;
  }

  function hasPointerCursor(el) {
    for (var n = el, i = 0; n && n.nodeType === 1 && i < 4; n = n.parentElement, i++) {
      if (getComputedStyle(n).cursor === 'pointer') return true;
    }
    return false;
  }

  function selectorOf(el) {
    var parts = [];
    for (var n = el, depth = 0; n && n.nodeType === 1 && n !== document.body && depth < 4; n = n.parentElement, depth++) {
      var s = n.tagName.toLowerCase();
      if (n.id && /^shopify-section-/.test(n.id)) break;
      if (n.id && !/^\d|template--|[0-9a-f]{8,}|-\d{6,}/i.test(n.id)) { parts.unshift(s + '#' + n.id); break; }
      var cls = (typeof n.className === 'string' ? n.className : '').trim().split(/\s+/).filter(function (c) {
        return c && c.length < 40 && !/^(is-|has-|js-)|active|open|loaded|animate|scroll-trigger|focus|hover|playing|paused|selected/.test(c);
      }).slice(0, 2);
      if (cls.length) s += '.' + cls.join('.');
      parts.unshift(s);
    }
    return parts.join('>').slice(0, 160);
  }

  function labelOf(el) {
    if (el.tagName === 'INPUT' && /submit|button/.test(el.type)) return String(el.value || '').slice(0, 80);
    if (/^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName)) return '[' + (el.name || el.type || 'feld') + ']';   // nie Eingaben
    var t = el.getAttribute('aria-label') || el.getAttribute('title') || el.innerText || el.getAttribute('alt') || '';
    if (!t && el.tagName === 'IMG') t = 'bild:' + fileOf(el.currentSrc || el.src);
    if (!t) { var img = el.querySelector && el.querySelector('img[alt]'); if (img) t = img.alt; }
    return String(t).replace(/\s+/g, ' ').trim().slice(0, 80);
  }

  // Bestell-, Download- und Zugangskennungen (z. B. Filemonk-Downloadseiten) nie speichern:
  // UUIDs, lange Zahlen und lange Zeichenketten mit Ziffern ohne Bindestrich werden zu ":id"
  // (Produkt-Handles haben Bindestriche und bleiben).
  function cleanPath(p) {
    return String(p || '').split('/').map(function (seg) {
      if (/^[0-9a-f]{8}-[0-9a-f]{4}-/i.test(seg) || /^\d{6,}$/.test(seg) || (/\d/.test(seg) && /^[A-Za-z0-9_]{16,}$/.test(seg))) return ':id';
      return seg;
    }).join('/');
  }

  function linkOf(a) {
    try {
      var u = new URL(a.href, location.href);
      if (u.host === location.host) return cleanPath(u.pathname).slice(0, 120);
      return u.host.replace(/^www\./, '') + cleanPath(u.pathname).slice(0, 60);
    } catch (e) { return ''; }
  }

  function fileOf(url) {
    if (!url) return '';
    if (/^(blob|data):/.test(url)) return url.slice(0, 4);
    try {
      var u = new URL(url, location.href);
      var f = decodeURIComponent(u.pathname.split('/').pop() || u.host);
      return (u.host === location.host || /cdn\.shopify\.com$/.test(u.host) ? '' : u.host + '/') + f.slice(0, 100);
    } catch (e) { return String(url).slice(0, 100); }
  }
})();
